/**
 * Prueft, ob ein Aktualitaets-Zeitstempel eine echte Aussage traegt.
 *
 * model.title_update_order (V0110) fuehrt fuer Titel ohne jeden API-Kontakt
 * 'epoch' statt NULL - das haelt den Keyset-Tupelvergleich NULL-frei, ist als
 * Anzeige aber wertlos: "01.01.1970" waere eine Zahl, die eine Aussage
 * vortaeuscht, wo keine ist. Betroffen sind 304.040 von 545.788 Titeln, also
 * die Mehrheit; die Pruefung ist damit der Normalfall, nicht der Randfall.
 *
 * Verglichen wird gegen 1990 und nicht exakt gegen den Epoch-Wert, damit auch
 * eine spaeter geaenderte Sentinel-Wahl nicht versehentlich als echtes Datum
 * durchgeht. Ein Ingest-Zeitstempel liegt immer in der Gegenwart, eine untere
 * Schranke kostet also nichts.
 */
export function isRealUpdateTimestamp(iso: string | undefined): boolean {
  if (!iso) return false;
  const d = new Date(iso);
  return !Number.isNaN(d.getTime()) && d.getUTCFullYear() >= 1990;
}
